module.exports = __webpack_public_path__ + "media/application/images/svgs/box-d9fc736205ff94f8280b5c28e9b7a397.svg";